import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Navigation from './ui/Navigation/Navigation';
import Header from './ui/Header/Header';
import { Box, useTheme, useMediaQuery } from '@mui/material';

const ResponsiveLayout = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [isNavigationOpen, setIsNavigationOpen] = useState(false);

  useEffect(() => {
    // Set initial navigation state based on screen size
    setIsNavigationOpen(!isMobile);
  }, [isMobile]);

  const handleNavigationToggle = () => {
    setIsNavigationOpen(!isNavigationOpen);
  };

  const handleNavigationClose = () => {
    setIsNavigationOpen(false);
  };

  // Don't show layout for auth pages or if user is not logged in
  const authPages = ['/login', '/unauthorized'];
  const isAuthPage = authPages.includes(location.pathname);

  if (!user || isAuthPage) {
    return children;
  }

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Navigation Sidebar */}
      <Navigation
        isOpen={isNavigationOpen}
        onToggle={handleNavigationToggle}
        onClose={handleNavigationClose}
      />

      {/* Main Content Area */}
      <Box
        sx={{
          flexGrow: 1,
          //marginLeft: !isMobile && isNavigationOpen ? '280px' : 0,
          transition: theme => theme.transitions.create(['margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          width: '100%',
          backgroundColor: theme => theme.palette.background.default
        }}
      >
        {/* Header */}
        <Header
          onMenuToggle={handleNavigationToggle}
          showMenuButton={isMobile}
        />

        {/* Page Content */}
        <Box
          component="main"
          sx={{
            p: 3,
            flexGrow: 1,
            overflow: 'auto'
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default ResponsiveLayout;